<tm2-anamnese-questionaire-simple
 	[product]="anamnese?.product"
	[formData]="formData"
	(action)="onAction($event)"
></tm2-anamnese-questionaire-simple>




